import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";
import { transformTemplateToBlueprint, type DatabaseTemplate } from "@/utils/templateTransformers";
import type { Blueprint } from "@/components/ui/blueprint-card";

export const useMarketingTemplates = () => {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: ["marketing-templates", i18n.resolvedLanguage || i18n.language],
    queryFn: async (): Promise<Blueprint[]> => {
      const { data, error } = await supabase
        .rpc('get_public_templates_with_counts');
      
      if (error) {
        console.error("Error fetching templates:", error);
        throw error;
      }
      
      if (!data || data.length === 0) {
        return [];
      }
      
      // Transform database rows to Blueprint interface
      return data.map((template: DatabaseTemplate) => 
        transformTemplateToBlueprint(template)
      );
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
  });
};
